<bw-modal-legacy
  *ngIf="showHalfsheet && halfSheetSettings"
  [brightsideWebFb]="displayAnalytics.shown"
  (closeModal)="showHalfsheet = false"
  [showCloseButton]="halfSheetSettings.data.dismissable"
>
  <typography-legacy title-medium color="var(--gray-70)">{{ halfSheetSettings.data.title || '' | translate }}</typography-legacy>
  <section class="body">
    <bw-paragraph-legacy [textStyle]="'Body2'" color="var(--gray-50)"
      ><span [innerHTML]="halfSheetSettings.data.subText || '' | translate"></span
    ></bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button
        bw-button-legacy
        [ngStyle]="{ 'background-color': 'var(--error)' }"
        [brightsideWebFb]="displayAnalytics.submit"
        (click)="onPrimaryClick()"
      >
        {{ halfSheetSettings.data.primaryCta.label || 'OK' | translate }}
      </button>
      <a bw-anchor-legacy [brightsideWebFb]="displayAnalytics.dismiss" (click)="onSecondaryClick()" style="margin: 0 16px">{{
        halfSheetSettings.data.secondaryCta.label || 'BUTTON_CANCEL' | translate
      }}</a>
    </div>
  </footer>
</bw-modal-legacy>
